import styled from "styled-components";

export const SidebarText = styled.span`
  color: ${(props) => props.theme.colors?.tertiary};
  font-weight: bold;
  font-size: 1rem;
  text-align: left;
`;
